module.exports = __webpack_public_path__ + "/images/ico-color-heart-lock.7fb832f.svg";